import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import styles from './ActionSheetContainer.module.css';

type ActionSheetContainerProps = {
  children: React.ReactNode;
  onPrimaryButtonClick: () => void;
  primaryButtonLabel?: string;
};

export const ActionSheetContainer = ({
  children,
  onPrimaryButtonClick,
  primaryButtonLabel = 'Cancel',
}: ActionSheetContainerProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content}>{children}</div>
      <motion.button
        className={styles.primaryButton}
        onClick={onPrimaryButtonClick}
        whileTap={{ scale: 0.9 }}
        transition={{ type: 'ease' }}
      >
        {t(primaryButtonLabel)}
      </motion.button>
    </div>
  );
};
